import { mapActions } from 'vuex'
import { EmptyView, ListAllBots } from '../../components/index'

export default {
  components: {
    EmptyView,
    ListAllBots
  },
  data () {
    return {
      allBots: []
    }
  },
  mounted () {
    this.setAllBots()
  },
  methods: {
    ...mapActions([
      'actionGetLocalStorageAllBots'
    ]),
    async setAllBots () {
      this.allBots = await this.actionGetLocalStorageAllBots()
    }
  }
}
